import arrowLeft from 'public/static/images/small-black-arrow-left.png';
import { useState } from 'react';
import { colors } from 'components/styles/variables';
import { CreateEmailAccountParams } from 'types/Auth';
import LoginWithEmailForm from './LogInByEmail';
import CreateAccountByEmailForm from './CreateAccountByEmail';
import CreateAccountOptions from './CreateAccount';
import LoginOptions from './Login';
import ForgotPasswordForm from './ForgotPassword';

enum Stages {
  CreateAccount,
  CreateAccountByEmail,
  Login,
  LoginWithEmail,
  ForgotPassword,
}

function BackButton({ onClick }: { onClick(): void }): JSX.Element {
  return (
    <>
      <button className="back" onClick={onClick} data-testid="back-button" />
      <style jsx>{`
        margin: 12px;
        height: 20px;
        width: 20px;
        border: 0;
        padding: 0;
        color: ${colors.G4};
        cursor: pointer;
        background: url(${arrowLeft}) no-repeat;
        background-size: 10px 16px;
        background-position: 0x 0px;
      `}</style>
    </>
  );
}

export interface Props {
  onClickGoogle(): void;
  onClickFacebook(): void;
  onSubmitLoginWithEmail({ email, password }: { email: string; password: string }): void;
  onSubmitResetPassword({ email }: { email: string }): void;
  onSubmitCreateAccountByEmail({ email, password, acceptEmails }: CreateEmailAccountParams): void;
}

export default function Flow({
  onClickGoogle,
  onClickFacebook,
  onSubmitLoginWithEmail,
  onSubmitResetPassword,
  onSubmitCreateAccountByEmail,
}: Props): JSX.Element {
  const [stage, setStage] = useState<Stages>(Stages.CreateAccount);

  switch (stage) {
    case Stages.CreateAccount: {
      return (
        <CreateAccountOptions
          onClickEmail={(): void => {
            setStage(Stages.CreateAccountByEmail);
          }}
          onClickLogin={(): void => {
            setStage(Stages.Login);
          }}
          onClickGoogle={onClickGoogle}
          onClickFacebook={onClickFacebook}
        />
      );
    }
    case Stages.Login: {
      return (
        <LoginOptions
          onClickFacebook={onClickFacebook}
          onClickGoogle={onClickGoogle}
          onClickEmail={(): void => {
            setStage(Stages.LoginWithEmail);
          }}
          onClickCreateAccount={(): void => {
            setStage(Stages.CreateAccount);
          }}
        />
      );
    }
    case Stages.LoginWithEmail: {
      return (
        <>
          <BackButton
            onClick={(): void => {
              setStage(Stages.Login);
            }}
          />
          <LoginWithEmailForm
            onSubmit={({ email, password }): void => {
              onSubmitLoginWithEmail({ email, password });
            }}
            onForgotPasswordClick={(): void => {
              setStage(Stages.ForgotPassword);
            }}
          />
        </>
      );
    }
    case Stages.ForgotPassword: {
      return (
        <>
          <BackButton
            onClick={(): void => {
              setStage(Stages.LoginWithEmail);
            }}
          />
          <ForgotPasswordForm
            onSubmit={({ email }): void => {
              onSubmitResetPassword({ email });
            }}
          />
        </>
      );
    }
    case Stages.CreateAccountByEmail: {
      return (
        <>
          <BackButton
            onClick={(): void => {
              setStage(Stages.CreateAccount);
            }}
          />
          <CreateAccountByEmailForm onSubmit={onSubmitCreateAccountByEmail} />
        </>
      );
    }
    default: {
      throw Error('no stage');
    }
  }
}
